
import type { LoanListItem } from '@app/shared';
import type { Column } from './columns';

// Header cells and data cells, both generated from the same column descriptors —
// so a column's header, sort behaviour and rendering can never drift apart.

export function SortableHeaders({ columns, onSort, indicator }: {
  columns: Column[];
  onSort: (id: string) => void;
  indicator: (id: string) => string;
}) {
  return (
    <>
      {columns.map(c => (
        <th
          key={c.id}
          className={c.sortable === false ? undefined : 'sortable'}
          onClick={c.sortable === false ? undefined : () => onSort(c.id)}
          title={c.sortable === false ? undefined : `Sort by ${c.header}`}
        >
          {c.header}{indicator(c.id)}
        </th>
      ))}
    </>
  );
}

export function DataCells({ columns, row }: { columns: Column[]; row: LoanListItem }) {
  return (
    <>
      {columns.map(c => (
        <td key={c.id} className={c.cellClass?.(row)}>{c.render?.(row)}</td>
      ))}
    </>
  );
}
